<template>
  <v-card>
    <v-card-title class="text-center justify-center">
      <div>{{ title }}</div>
    </v-card-title>
    <v-divider class="ma-0" />
    <div class="d-flex flex-column px-8">
      <v-combobox
        v-model="recipients"
        outlined
        dense
        hide-details
        label="Recipient"
        multiple
        class="my-4"
      >
        <template v-slot:selection="{ attrs, item, select, selected }">
          <v-chip
            v-bind="attrs"
            :input-value="selected"
            close
            @click="select"
            @click:close="removeRecipient(item)"
          >
            {{ item }}
          </v-chip>
        </template>
        <!-- <template v-slot:no-data>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title> Press <kbd>enter</kbd> to add a new recipient </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template> -->
      </v-combobox>
      <v-text-field
        v-model="subject"
        outlined
        dense
        hide-details
        label="Subject"
        class="my-4"
      ></v-text-field>
      <v-textarea
        v-model="message"
        outlined
        dense
        hide-details
        label="Message (optional)"
        class="my-4"
      ></v-textarea>
      <div class="text-color-555555">{{ selectedMessage }}</div>
    </div>

    <v-card-actions class="d-flex justify-center py-8">
      <v-btn
        color="primary"
        class="text-capitalize"
        :loading="sending"
        :disabled="sending"
        @click="sendMessage"
      >
        Send message
      </v-btn>
    </v-card-actions>

    <v-snackbar v-model="emailSuccessSnackBar" multi-line>
      <div class="font-weight-bold">Successfully sent email</div>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="emailSuccessSnackBar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="emailErrorSnackBar" multi-line>
      <div class="font-weight-bold">
        Could not send email. Please try again.
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="emailErrorSnackBar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { post } from '@/js/api/sourcer';
import consola from 'consola';
import Config from '@/js/config';

export default {
  props: {
    projectId: String,
    candidates: Array,
  },

  data() {
    return {
      subject: 'Check out those awesome candidates!',
      recipients: [],
      message: '',
      sending: false,
      emailSuccessSnackBar: false,
      emailErrorSnackBar: false,
    };
  },

  computed: {
    title() {
      const project = this.getSettingsByProjectId(this.projectId);
      if (project && project.job_title) {
        return `Share Approved Candidates - ${project.job_title}`;
      }
      return ' ';
    },

    selectedMessage() {
      if (this.candidates.length > 1) {
        return `${this.candidates.length} selected candidates will be shared`;
      }
      return `${this.candidates.length} selected candidate will be shared`;
    },

    ...mapGetters('projects/settings', ['getSettingsByProjectId']),
  },

  created() {
    this.$store.dispatch('projects/settings/loadSettings', {
      projectId: this.projectId,
    });
  },

  methods: {
    removeRecipient(recipient) {
      this.recipients.splice(this.recipients.indexOf(recipient), 1);
      this.recipients = [...this.recipients];
    },

    async sendMessage() {
      try {
        this.sending = true;
        const response = await post(`${Config.env.API_URL}share`, {
          candidate_ids: this.candidates.map((cand) => cand._id),
          to_emails: this.recipients,
          email_subject: this.subject,
          email_body: this.message,
        });
        this.sending = false;

        if (response && response.status === 200) {
          consola.info('Successfully sent email');
          this.emailSuccessSnackBar = true;
          this.$emit('emailSent');
        }
      } catch (error) {
        consola.info("Couldn't send email");
        this.sending = false;
        this.emailErrorSnackBar = true;
      }
    },
  },
};
</script>

<style scoped></style>
